import { NewPeriodSelectorInterval } from 'src/app/core/enums/newPeriodSelectorInterval';
import { NewPeriodSelectorIntervalType } from 'src/app/core/enums/newPeriodSelectorIntervalType';
import { NewPeriodFilter } from 'src/app/core/models/period-selector/newPeriodFilter';
import { NewPeriodSelectorConfiguration } from 'src/app/core/models/period-selector/newPeriodSelectorConfiguration';

export class NewPeriodSelectorItem {
  name: string;
  intervalType: NewPeriodSelectorIntervalType;
  interval: NewPeriodSelectorInterval;
  isActive = false;
  hasNavigation: boolean;
  constructor(name: string) {
    this.name = name;
  }
  getPeriodFilter: () => NewPeriodFilter;
  getPreviousPeriodFilter: (currentPeriodFilter) => NewPeriodFilter;
  getNextPeriodFilter: (currentPeriodFilter) => NewPeriodFilter;
  isVisible = (config: NewPeriodSelectorConfiguration) => {
    return config.visibleItems.find(it => it === this.interval) !== undefined
  }
}
